import { render, staticRenderFns } from "./Soldiers.vue?vue&type=template&id=d28f8fb6&"
import script from "./Soldiers.vue?vue&type=script&lang=js&"
export * from "./Soldiers.vue?vue&type=script&lang=js&"
import style0 from "./Soldiers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Soldiers.vue"
export default component.exports